import axios from 'axios';

axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-Token': document.head.querySelector('[name=csrf-token]')?.content,
};
